<!-- 问答管理 -->
<template>
  <div class="container">
    <header class="header">
      <el-tabs style="width: 100%" v-model="activeName">
        <el-tab-pane label="新问答汇总" name="1">
          <allQuestions selsect="全部" state="1"></allQuestions>
        </el-tab-pane>
        <el-tab-pane label="我回答的" name="2">
          <allQuestions selsect="全部已回答" state="2"></allQuestions>
        </el-tab-pane>
        <el-tab-pane label="我提问的" name="3">
          <allQuestions selsect="全部我的提问"  state="3"></allQuestions>
        </el-tab-pane>
      </el-tabs>
    </header>
  </div>
</template>

<script>
import allQuestions from "./child/allQuestions.vue";
export default {
  components: {
    allQuestions,
  },
  data() {
    return {
      activeName: "1",
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
/deep/ .el-tabs__nav-scroll {
  display: flex;
  align-items: center;
  justify-content: center;
}
.container {
  background-color: #fff;
  padding: 0.1rem;
  .header {
    display: flex;
    justify-content: center;
  }
}
</style>
